var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInventoryDark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.4 4.7C7.4 6.19117 6.19117 7.4 4.7 7.4C3.20883 7.4 2 6.19117 2 4.7C2 3.20883 3.20883 2 4.7 2C6.19117 2 7.4 3.20883 7.4 4.7Z",
    stroke: "#68D3C1",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 4.7C20 6.19117 18.7912 7.4 17.3 7.4C15.8088 7.4 14.6 6.19117 14.6 4.7C14.6 3.20883 15.8088 2 17.3 2C18.7912 2 20 3.20883 20 4.7Z",
    stroke: "#68D3C1",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.4 17.3C7.4 18.7911 6.19117 20 4.7 20C3.20883 20 2 18.7911 2 17.3C2 15.8088 3.20883 14.6 4.7 14.6C6.19117 14.6 7.4 15.8088 7.4 17.3Z",
    stroke: "#68D3C1",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20 17.3C20 18.7911 18.7912 20 17.3 20C15.8088 20 14.6 18.7911 14.6 17.3C14.6 15.8088 15.8088 14.6 17.3 14.6C18.7912 14.6 20 15.8088 20 17.3Z",
    stroke: "#68D3C1",
    strokeWidth: 2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.4 17.3H14.6",
    stroke: "#68D3C1",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.4 4.70001H14.6",
    stroke: "#68D3C1",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3 14.6L17.3 7.39998",
    stroke: "#68D3C1",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M4.7 14.6L4.7 7.39998",
    stroke: "#68D3C1",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInventoryDark);
export default __webpack_public_path__ + "static/media/InventoryDark.5ccc01400c17c44369d1e3b10ea9ef04.svg";
export { ForwardRef as ReactComponent };